
/**
 * @license AngularJS v2.0.0
 * (c) 2010-2020 Google, Inc. http://angularjs.org
 * License: MIT
 * Forked maintenance by PebblePad
 */
'use strict';
export class NgComponent {
  constructor() {
    if (window.angular.$$compilationBindings.current !== null) {
      Object.assign(this, window.angular.$$compilationBindings.current);
    }
  }
}
